module.exports = "/packs/check-2bb105be4d33f6e43fdd739cd2fd11d0.svg";